import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { toast } from "react-toastify";

export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          toast.success("Payment succeeded!")
          break;
        case "processing":
          setMessage("Your payment is processing.");
          toast.error("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          toast.error("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          toast.error("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);
    setMessage(null); // clear the previous attempt's message

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // origin carries scheme, host and port together. Building this from
        // window.location.hostname produced "https://localhost/main" when run
        // locally — wrong scheme, port dropped — which strands any method that
        // needs the redirect round trip.
        return_url: `${window.location.origin}/main`,
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error) {
      if (error.type === "validation_error") {
        // PaymentElement already prints these under the field that caused them
        // ("Your card number is incomplete."). Repeating the text below the
        // button showed every incomplete-field message twice.
        setMessage(null);
      } else if (error.type === "card_error") {
        // Declines are not rendered by the element, so they do need surfacing.
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occurred. Please try again.");
        toast.error("An unexpected error occurred. Please try again.");
      }
    }

    setIsLoading(false);
  };

  return (
    <div className="payment-modal">
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement id="payment-element" />
       <div className="w-100 d-flex justify-content-center">
       <button disabled={isLoading || !stripe || !elements} id="submit" className="bg-danger border-0 rounded-pill mt-3">
          <span
            id="button-text"
            className="btn btn-danger d-flex justify-content-center rounded-pill"
          >
            {isLoading ? (
              <div className="spiner" id="spinner"></div>
            ) : (
              "Pay now"
            )}
          </span>
        </button>
       </div>
        {/* Show any error or success messages */}
        {message && <div id="payment-message">{message}</div>}
      </form>
    </div>
  );
}
